module.exports = __webpack_public_path__ + "static/media/default-product-image.754c651b.svg";